/**
 * WordPress dependencies
 */
import { SVG, Path } from '@safe-wordpress/primitives';

const icon = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
		<Path d="M 2.5,2.5000002 V 17.5 h 15 V 2.5000002 Z M 4.375,12.8125 h 11.25 V 15.625 H 4.375 Z" />
	</SVG>
);

export default icon;
